import React from 'react';
export default  ({visible,children,Children=props=>null})=>(visible?[children,<Children/>]:null);
